import Button from '@ingka/button';
import documentIcon from '@ingka/ssr-icon/paths/document';
import trashCan from '@ingka/ssr-icon/paths/trash-can';
import Text from '@ingka/text';
import Tooltip from '@ingka/tooltip';
import { translate } from '@repo/phrase';
import type { AppendixRow } from '@repo/types/docusign';

import styles from './styles.module.scss';

interface AppendixViewContentProps {
    rows: AppendixRow[];
    onDelete: (id: string) => void;
}

const viewDocument = (file: File) => {
    const url = URL.createObjectURL(file);
    globalThis.open(url, '_blank');
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 1000);
};

export const AppendixViewContent = ({ rows, onDelete }: AppendixViewContentProps) => {
    return (
        <div className={styles.list} data-testid="appendix-view">
            {rows.map((row) => {
                const viewDocumentLabel = `${translate('docusign_view_document')}: ${row.file.name}`;
                const deleteDocumentLabel = `${translate('docusign_delete_document')}: ${row.file.name}`;

                return (
                    <div key={row.id} className={styles.row}>
                        <div className={styles.colName}>
                            <Text tagName="span" textStyle="Body.S" className={String(styles.docLabel)}>
                                {row.file.name}
                            </Text>
                        </div>
                        <Tooltip
                            describedById={`view-tooltip-${row.id}`}
                            tooltipText={translate('docusign_view_document')}
                            position="bottom"
                        >
                            <Button
                                type="primary"
                                iconOnly
                                ssrIcon={documentIcon}
                                size="small"
                                data-testid={`appendix-view-${row.id}`}
                                aria-label={viewDocumentLabel}
                                onClick={() => {
                                    viewDocument(row.file);
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            describedById={`delete-tooltip-${row.id}`}
                            tooltipText={translate('docusign_delete_document')}
                            position="bottom"
                        >
                            <Button
                                type="secondary"
                                iconOnly
                                ssrIcon={trashCan}
                                size="small"
                                data-testid={`appendix-delete-${row.id}`}
                                aria-label={deleteDocumentLabel}
                                onClick={() => {
                                    onDelete(row.id);
                                }}
                            />
                        </Tooltip>
                    </div>
                );
            })}
        </div>
    );
};
